
/* 오래된 서비스워커·캐시 때문에 옛 화면이 보이는 문제 자가 복구.
   빌드 태그가 바뀌면 캐시를 비우고 서비스워커 갱신을 요청한다(새로고침은 하지 않는다). */
(function(){
  var BUILD='20260808-krds-32';
  /* 예전 버전에서 기기에 영구 저장된 교사 플래그를 제거 (키오스크 결과지 선행 노출 원인) */
  try{ localStorage.removeItem('pia_aud_teacher'); }catch(e){}
  try{
    var prev=null;
    try{ prev=localStorage.getItem('pia_build'); }catch(e){}
    if(prev!==BUILD){
      try{ localStorage.setItem('pia_build', BUILD); }catch(e){}
      if(window.caches && caches.keys){
        caches.keys().then(function(keys){
          return Promise.all(keys.map(function(k){ return caches.delete(k); }));
        }).catch(function(){});
      }
      if(navigator.serviceWorker && navigator.serviceWorker.getRegistrations){
        navigator.serviceWorker.getRegistrations().then(function(rs){
          rs.forEach(function(r){ try{ r.update(); }catch(e){} });
        }).catch(function(){});
      }
    }
  }catch(e){ if(window.console) console.error('빌드 갱신 확인 실패:', e); }

  /* [2026-09-26] 서비스워커가 바뀌었다고(controllerchange·SW_UPDATED) 새로고침하지 않는다.
     검사 도중 배포되면 진행이 통째로 초기화됐다(controllerchange 는 새 워커 활성화·
     clients.claim() 때마다 열린 화면 전부에 온다). HTML·JS 는 서비스워커가 network-first 로
     주므로 다음 이동부터 새 내용이 저절로 닿는다. */
})();
